import { CaseStudiesGrid } from './CaseStudiesGrid';
export default CaseStudiesGrid;
